import EntityForm from "../../components/EntityForm"
import { renderFormField } from "../../components/FormFields"
import { useTranslation } from "react-i18next"

export default function RoleForm() {
  const { t } = useTranslation()
  const fields = [
    {
      name: "name",
      label: t("fields.name"),
      type: "text" as const,
      required: true,
    },
  ]
  return <EntityForm title={t("roles.formTitle")} endpoint="/role" fields={fields} listPath="/role" renderField={renderFormField} />
}
